const ConfigurationFactory = require("../ConfigurationFactory");
const PlayerIntegration = require("./PlayerIntegration");
const Logger = require("../Logger");

const service = {};

const subscriptionBridges = new Map();

service.getBridge = () => {
  return new PalmServiceBridge();
};

service.initWebOSRisePlayer = () => {
  if (!ConfigurationFactory.isWebOSPlayer()) { return; }

  const scapBase = getScapServiceBase();

  window.RisePlayer = {
    requestRestart() {
      lunaCall(`${scapBase}/restart`, {});
    },
    requestReboot() {
      lunaCall(`${scapBase}/reboot`, {});
    },
    turnDisplayOn() {
      lunaCall(`${scapBase}/displayControl`, { state: 'on' });
    },
    turnDisplayOff() {
      lunaCall(`${scapBase}/displayControl`, { state: 'off' });
    },
    requestScreenshot(url, clientId) {
      lunaCall(`${scapBase}/writeScreenshot`, {url}, resp => {
        if (resp && resp.returnValue) {
          PlayerIntegration.sendScreenshotSaved(clientId)
        } else {
          PlayerIntegration.sendScreenshotFailed(clientId);
          console.debug(resp)
        }
      });
    },
    requestFirmwareUpgrade(url, cb) {
      const TWENTY_MINUTES = 1200000;

      lunaCall(`${scapBase}/firmwareUpgrade`, {url, subscribe: true}, cb, { timeout: TWENTY_MINUTES });
    },
    subscribeToScreenPowerStatusUpdates(cb) {
      lunaCall(`${scapBase}/subscribeScreenPower`, {subscribe: true, interval: 5000}, cb, { timeout: 0 });
    },
    setHeartbeatInterval(interval) {
      Logger.viewerInfo("setHeartbeatInterval", interval);
      const serviceReadyDelay = 90000;

      setTimeout(subscribeToHeartbeats, serviceReadyDelay);

      function subscribeToHeartbeats() {
        Logger.viewerInfo("Subscribing to heartbeats");

        lunaCall(`${scapBase}/initiateHeartbeats`, {interval, subscribe: true}, ({returnValue, eventApp, eventAppVersion, errorText}) => {
          console.debug("Heartbeat callback", eventApp, eventAppVersion, returnValue, errorText);
          Logger.viewerInfo("Heartbeat callback", {eventApp, eventAppVersion, returnValue, errorText});

          if (eventApp && eventAppVersion) {
            Logger.recordUptimeHeartbeat({eventApp,eventAppVersion})
          }
        }, { timeout: 0 })
      }
    },
    setVolumeLevel(volumeLevel) {
      lunaCall(`${scapBase}/setVolume`, { volume: volumeLevel }, (resp) => {
        if (resp && !resp.returnValue) {
          Logger.viewerError(
            'E000000113',
            "Failed to set volume on WebOS",
            { errorMessage: resp.errorText || 'Unknown error'}
          );
        }
      });
    },
    requestVolumeLevel() {
      lunaCall(`${scapBase}/getVolume`, {}, (resp) => {
        if (resp.returnValue) {
          PlayerIntegration.notifyCurrentVolumeLevel(resp.volume);
        } else {
          PlayerIntegration.notifyCurrentVolumeLevelReadError(
            resp.errorText || 'Error reading WebOS volume level'
          )
        }
      });
    },
    setDevicePhysicalButtonsMode(mode) {
      lunaCall(`${scapBase}/setDevicePhysicalButtonsMode`, { mode });
    },
    schedulePowerOn(time) {
      lunaCall(`${scapBase}/schedulePowerOn`, { time }, (resp) => {
        console.debug('Schedule Power On callback: ', resp)
        if (resp && !resp.returnValue) {
          Logger.viewerError(
            'E000000113',
            "Failed to schedule power on on WebOS",
            { errorMessage: resp.errorText || 'Unknown error'}
          );
        }
      });
    }
  };
};

module.exports = service;

function getScapServiceBase() {
  const id = window.PalmSystem && window.PalmSystem.identifier;

  if (!id) {
    Logger.log("WEB_OS_IDS missing; defaulting SCAP base to prod.");
    return "luna://com.lg.app.signage.scapservice";
  }

  return `luna://${id}.scapservice`;
}

function lunaCall(uri, params = {}, cb, { timeout = 8000 } = {}) {
  const bridge = service.getBridge();

  if (params.subscribe) {
    if (subscriptionBridges.has(uri)) {
      try {
        Logger.viewerInfo("Cancelling duplicated subscription", uri);
        subscriptionBridges.get(uri).cancel();
      } catch (e) {}
    }

    subscriptionBridges.set(uri, bridge);
  }

  let finished = false;

  const done = () => {
    if (finished) return;
    finished = true;
    Logger.viewerInfo("Lunacall done", uri);

    bridge.onservicecallback = null;
    clearTimeout(to);
    try { bridge.cancel(); } catch (e) {}

    if (params.subscribe && subscriptionBridges.get(uri) === bridge) {
      subscriptionBridges.delete(uri);
    }
  };

  let to = null;
  if (timeout !== 0) {
    to = setTimeout(() => {
      Logger.logException("WebOSRisePlayer.lunaCall", new Error(`timeout for ${uri}`));
      done();
    }, timeout);
  }

  bridge.onservicecallback = (resp) => {
    Logger.viewerInfo("onserviceCallback", resp);

    if (finished) return;

    try {
      const respObj = JSON.parse(resp);

      if (respObj.subscribed !== true) {
        console.log("Luna subscription ended")
        clearTimeout(to);
        done();
      }

      if (typeof cb === "function") {
        cb(respObj);
      }
    } catch (err) {
      console.error("Luna error", err)
      clearTimeout(to);
      done();

      if (typeof cb === "function") {
        cb(resp);
      }
    }
  };

  bridge.call(uri, JSON.stringify(params));
}
